import React, { Component } from 'react';
import { connect } from 'react-redux';
import {
    Card,
    CardContent,
    Typography,
    Grid,
    Box,
    Button,
    CircularProgress,
    Chip,
    Paper,
    Table,
    TableBody,
    TableCell,
    TableContainer,
    TableHead,
    TableRow,
    TablePagination,
    TextField,
    Tabs,
    Tab,
    withStyles
} from '@material-ui/core';
import {
    TrendingUp,
    Assessment,
    Timeline,
    Refresh,
    EuroSymbol
} from '@material-ui/icons';
import { Doughnut, Bar } from 'react-chartjs-2';
import FilterSelect from '../components/filterSelect';
import FilterInput from '../components/filterInput';
import TreeClient from '../components/treeClient';
import { addDayToToday } from '../helpers/functions';
import {
    getStade,
    getMetaux,
    getTypeProduit,
    getStatut,
    getAnalyseMargeTotaux,
    getAnalyseMargeClasses,
    getAnalyseMargeDetails,
    getAnalyseMargeEfficacite,
    getAnalyseMargeTotauxLivres,
    getAnalyseMargeClassesLivres,
    getAnalyseMargeDetailsLivres,
    getAnalyseMargeEfficaciteLivres
} from '../actions';

const useStyles = theme => ({
    root: {
        flexGrow: 1,
        padding: theme.spacing(3),
        backgroundColor: '#f5f5f5'
    },
    headerCard: {
        background: 'linear-gradient(135deg, #667eea 0%, #764ba2 100%)',
        color: 'white',
        marginBottom: theme.spacing(3),
        borderRadius: theme.spacing(2)
    },
    kpiCard: {
        height: '180px',
        display: 'flex',
        flexDirection: 'column',
        justifyContent: 'center',
        alignItems: 'center',
        textAlign: 'center',
        borderRadius: theme.spacing(2),
        boxShadow: '0 8px 25px rgba(0,0,0,0.1)',
        transition: 'transform 0.3s ease, box-shadow 0.3s ease',
        '&:hover': {
            transform: 'translateY(-5px)',
            boxShadow: '0 12px 35px rgba(0,0,0,0.15)'
        },
        position: 'relative',
        overflow: 'hidden',
        '&::before': {
            content: '""',
            position: 'absolute',
            top: 0,
            left: 0,
            width: '100%',
            height: '4px',
            background: 'linear-gradient(90deg, #3498db, #2980b9)'
        }
    },
    kpiIcon: {
        fontSize: '3rem',
        marginBottom: theme.spacing(1),
        color: theme.palette.primary.main
    },
    kpiValue: {
        fontSize: '2.2rem',
        fontWeight: 'bold',
        color: theme.palette.text.primary
    },
    kpiLabel: {
        fontSize: '0.9rem',
        color: theme.palette.text.secondary,
        textTransform: 'uppercase',
        letterSpacing: '1px',
        fontWeight: 500
    },
    chartCard: {
        padding: theme.spacing(3),
        borderRadius: theme.spacing(2),
        boxShadow: '0 8px 25px rgba(0,0,0,0.1)',
        marginBottom: theme.spacing(3)
    },
    filterSection: {
        background: 'white',
        borderRadius: theme.spacing(2),
        padding: theme.spacing(3),
        marginBottom: theme.spacing(3),
        boxShadow: '0 5px 20px rgba(0,0,0,0.1)'
    },
    statusChip: {
        fontWeight: 'bold',
        fontSize: '0.75rem'
    },
    excellent: {
        backgroundColor: '#d4edda',
        color: '#155724'
    },
    bon: {
        backgroundColor: '#cce5ff',
        color: '#004085'
    },
    moyen: {
        backgroundColor: '#fff3cd',
        color: '#856404'
    },
    faible: {
        backgroundColor: '#f8d7da',
        color: '#721c24'
    },
    deficit: {
        backgroundColor: '#e2e3e5',
        color: '#383d41'
    },
    tableContainer: {
        backgroundColor: 'white',
        borderRadius: theme.spacing(2),
        boxShadow: '0 8px 25px rgba(0,0,0,0.1)'
    },
    positiveValue: {
        color: '#27ae60',
        fontWeight: 'bold'
    },
    negativeValue: {
        color: '#e74c3c',
        fontWeight: 'bold'
    },
    refreshButton: {
        background: 'linear-gradient(135deg, #3498db, #2980b9)',
        color: 'white',
        '&:hover': {
            background: 'linear-gradient(135deg, #2980b9, #1f618d)'
        }
    }
});

class AnalyseMarges extends Component {
    constructor(props) {
        super(props);
        const currentYear = new Date().getFullYear();

        this.dataDevis = [{ id: 2, description: 'TOUT' }, { id: 1, description: 'DEVIS' }, { id: 0, description: 'NORMAL' }];
        this.dataImperatif = [{ id: 2, description: 'TOUT' }, { id: 1, description: 'IMPERATIF' }, { id: 0, description: 'NORMAL' }];
        this.dataTypeCommande = [{ id: 2, description: 'TOUT' }, { id: 1, description: 'TOURNEE' }, { id: 0, description: 'NORMAL' }];
        this.dataFacon = [{ id: 2, description: 'TOUT' }, { id: 1, description: 'A FACON' }, { id: 0, description: 'NORMAL' }];

        this.state = {
            loading: false,
            stade: '',
            metal: '',
            type: '',
            statut: '',
            ref: '',
            of: '',
            client: '',
            ref_clt: '',
            tournee: null,
            debut: `${currentYear}-01-01`,
            fin: addDayToToday(30),
            devis: null,
            facon: null,
            imperatif: null,
            typecommande: null,
            
            // Pagination tableau
            page: 0,
            rowsPerPage: 10,
            
            // Onglets
            currentTab: 0,
            
            // État d'erreur
            error: null
        };
    }

    componentDidMount() {
        const { getStade, getMetaux, getTypeProduit, getStatut } = this.props;
        getStade();
        getMetaux();
        getTypeProduit();
        getStatut();
        
        // Charger les données initiales
        this.loadAllData();
    }

    getFilter = () => ({
        stade: this.state.stade,
        metal: this.state.metal,
        type: this.state.type,
        statut: this.state.statut,
        ref: this.state.ref,
        of: this.state.of,
        client: this.state.client,
        ref_clt: this.state.ref_clt,
        tournee: this.state.tournee ? this.state.tournee.id : 2,
        debut: this.state.debut,
        fin: this.state.fin,
        devis: this.state.devis ? this.state.devis.id : 2,
        facon: this.state.facon ? this.state.facon.id : 2,
        imperatif: this.state.imperatif ? this.state.imperatif.id : 2,
        type_commande: this.state.typecommande ? this.state.typecommande : 0
    });

    loadAllData = async () => {
        this.setState({ loading: true, error: null });
        
        try {
            const filters = this.getFilter();
            const { 
                getAnalyseMargeTotaux,
                getAnalyseMargeClasses, 
                getAnalyseMargeDetails,
                getAnalyseMargeEfficacite,
                getAnalyseMargeTotauxLivres,
                getAnalyseMargeClassesLivres,
                getAnalyseMargeDetailsLivres,
                getAnalyseMargeEfficaciteLivres
            } = this.props;
            
            // Charger toutes les données en parallèle
            await Promise.all([
                // Analyses en cours
                getAnalyseMargeTotaux(filters),
                getAnalyseMargeClasses(filters),
                getAnalyseMargeDetails(filters),
                getAnalyseMargeEfficacite(filters),
                // Analyses livrées
                getAnalyseMargeTotauxLivres(filters),
                getAnalyseMargeClassesLivres(filters),
                getAnalyseMargeDetailsLivres(filters),
                getAnalyseMargeEfficaciteLivres(filters)
            ]);

            this.setState({ loading: false });
            
        } catch (error) {
            console.error('Erreur lors du chargement des données:', error);
            this.setState({ 
                error: 'Erreur lors du chargement des données', 
                loading: false 
            });
        }
    };

    // Suppression de la méthode loadData car on utilise maintenant Redux

    onChange = (data, labelState) => {
        const label = labelState.toLowerCase();
        this.setState({ [label]: data });
    };

    handleChangeClient = (data) => {
        this.setState({ client: data });
    };

    handleChangePage = (event, newPage) => {
        this.setState({ page: newPage });
    };

    handleChangeRowsPerPage = (event) => {
        this.setState({ 
            rowsPerPage: parseInt(event.target.value, 10),
            page: 0 
        });
    };

    formatNumber = (number) => {
        if (number === null || number === undefined || isNaN(number)) return '0';
        return new Intl.NumberFormat('fr-FR', {
            minimumFractionDigits: 0,
            maximumFractionDigits: 2
        }).format(number);
    };

    getStatusChip = (pourcentage, marge, classes) => {
        let status, className;
        
        if (pourcentage >= 50 && marge >= 100) {
            status = 'EXCELLENT';
            className = classes.excellent;
        } else if (pourcentage >= 30 && marge >= 50) {
            status = 'BON';
            className = classes.bon;
        } else if (pourcentage >= 15 && marge >= 20) {
            status = 'MOYEN';
            className = classes.moyen;
        } else if (marge >= 0) {
            status = 'FAIBLE';
            className = classes.faible;
        } else {
            status = 'DÉFICIT';
            className = classes.deficit;
        }

        return (
            <Chip 
                label={status} 
                className={`${classes.statusChip} ${className}`}
                size="small"
            />
        );
    };

    renderKPIs = () => {
        const { classes, analyseMarges } = this.props;
        const { totaux } = analyseMarges;

        if (!totaux) return null;

        const kpis = [
            {
                title: 'CA',
                value: `${this.formatNumber(totaux.ca_total)} €`,
                icon: EuroSymbol,
                subtitle: `${totaux.total_commandes} commandes`
            },
            {
                title: 'Prix Revient €',
                value: `${this.formatNumber(totaux.cout_total)} €`,
                icon: Assessment,
                subtitle: `Coût moyen/commande`
            },
            {
                title: 'Marge Total',
                value: `${this.formatNumber(totaux.marge_totale)} €`,
                icon: TrendingUp,
                subtitle: `${this.formatNumber((totaux.marge_totale / totaux.ca_total * 100) || 0)}% global`,
                positive: (totaux.marge_totale / totaux.ca_total * 100) >= 30
            },
            {
                title: 'Efficacité/Temps',
                value: `${this.formatNumber(totaux.marge_totale / totaux.total_commandes)} €`,
                icon: Timeline,
                subtitle: `Marge par commande`
            }
        ];

        return (
            <Grid container spacing={3} style={{ marginBottom: 24 }}>
                {kpis.map((kpi, index) => {
                    const IconComponent = kpi.icon;
                    return (
                        <Grid item xs={12} sm={6} md={3} key={index}>
                            <Card className={classes.kpiCard}>
                                <CardContent style={{ padding: 16 }}>
                                    <IconComponent className={classes.kpiIcon} />
                                    <Typography className={classes.kpiLabel}>
                                        {kpi.title}
                                    </Typography>
                                    <Typography className={classes.kpiValue}>
                                        {kpi.value}
                                    </Typography>
                                    <Typography 
                                        variant="body2" 
                                        className={kpi.positive !== undefined ? 
                                            (kpi.positive ? classes.positiveValue : classes.negativeValue) : 
                                            ''
                                        }
                                    >
                                        {kpi.subtitle}
                                    </Typography>
                                </CardContent>
                            </Card>
                        </Grid>
                    );
                })}
            </Grid>
        );
    };

    // Méthode pour regrouper les données par tranches de marge absolue
    getMargeAbsolueData = () => {
        const { analyseMarges } = this.props;
        const { details } = analyseMarges;

        if (!details.length) return [];

        const tranches = [
            { label: '0-100€', min: 0, max: 100, count: 0, marge: 0 },
            { label: '100-200€', min: 100, max: 200, count: 0, marge: 0 },
            { label: '200-300€', min: 200, max: 300, count: 0, marge: 0 },
            { label: '300-500€', min: 300, max: 500, count: 0, marge: 0 },
            { label: '500-1000€', min: 500, max: 1000, count: 0, marge: 0 },
            { label: '≥1000€', min: 1000, max: Infinity, count: 0, marge: 0 }
        ];

        details.forEach(item => {
            const marge = parseFloat(item.marge_absolue || 0);
            const tranche = tranches.find(t => marge >= t.min && marge < t.max);
            if (tranche) {
                tranche.count++;
                tranche.marge += marge;
            }
        });

        return tranches;
    };

    getMargeAbsolueDataLivres = () => {
        const { analyseMarges } = this.props;
        const { detailsLivres } = analyseMarges;

        if (!detailsLivres.length) return [];

        const tranches = [
            { label: '0-100€', min: 0, max: 100, count: 0, marge: 0 },
            { label: '100-200€', min: 100, max: 200, count: 0, marge: 0 },
            { label: '200-300€', min: 200, max: 300, count: 0, marge: 0 },
            { label: '300-500€', min: 300, max: 500, count: 0, marge: 0 },
            { label: '500-1000€', min: 500, max: 1000, count: 0, marge: 0 },
            { label: '≥1000€', min: 1000, max: Infinity, count: 0, marge: 0 }
        ];

        detailsLivres.forEach(item => {
            const marge = parseFloat(item.marge_absolue || 0);
            const tranche = tranches.find(t => marge >= t.min && marge < t.max);
            if (tranche) {
                tranche.count++;
                tranche.marge += marge;
            }
        });

        return tranches;
    };

    renderCharts = () => {
        const { classes } = this.props;
        const margeData = this.getMargeAbsolueData();

        if (!margeData.length || margeData.every(t => t.count === 0)) return null;

        // Configuration pour le graphique en secteurs (par nombre de commandes)
        const doughnutData = {
            labels: margeData.filter(t => t.count > 0).map(item => item.label),
            datasets: [{
                data: margeData.filter(t => t.count > 0).map(item => item.count),
                backgroundColor: [
                    '#e74c3c',  // <100€
                    '#f39c12',  // <200€
                    '#f1c40f',  // <300€
                    '#3498db',  // <500€
                    '#2ecc71',  // <1000€
                    '#27ae60'   // >1000€
                ],
                borderWidth: 2,
                borderColor: '#fff'
            }]
        };

        const doughnutOptions = {
            responsive: true,
            maintainAspectRatio: false,
            legend: {
                position: 'bottom'
            }
        };

        // Configuration pour le graphique en barres (par valeur de marge)
        const barData = {
            labels: margeData.filter(t => t.count > 0).map(item => item.label),
            datasets: [{
                label: 'Marge Totale (€)',
                data: margeData.filter(t => t.count > 0).map(item => item.marge),
                backgroundColor: 'rgba(52, 152, 219, 0.8)',
                borderColor: 'rgba(52, 152, 219, 1)',
                borderWidth: 2
            }]
        };

        const barOptions = {
            responsive: true,
            maintainAspectRatio: false,
            scales: {
                yAxes: [{
                    ticks: {
                        beginAtZero: true,
                        callback: function(value) {
                            return new Intl.NumberFormat('fr-FR').format(value) + ' €';
                        }
                    }
                }]
            },
            legend: {
                display: false
            },
            layout: {
                padding: {
                    top: 30
                }
            },
            tooltips: {
                callbacks: {
                    label: function(tooltipItem, data) {
                        const value = tooltipItem.yLabel;
                        return 'Marge: ' + new Intl.NumberFormat('fr-FR', { 
                            style: 'currency', 
                            currency: 'EUR', 
                            maximumFractionDigits: 0 
                        }).format(value);
                    }
                }
            }
        };

        return (
            <>
                <Grid container spacing={3} style={{ marginBottom: 24 }}>
                    <Grid item xs={12} md={6}>
                        <Paper className={classes.chartCard}>
                            <Typography variant="h6" style={{ marginBottom: 16, textAlign: 'center' }}>
                                Répartition par Marge
                            </Typography>
                            <div style={{ height: '300px' }}>
                                <Doughnut data={doughnutData} options={doughnutOptions} />
                            </div>
                        </Paper>
                    </Grid>
                    <Grid item xs={12} md={6}>
                        <Paper className={classes.chartCard}>
                            <Typography variant="h6" style={{ marginBottom: 16, textAlign: 'center' }}>
                                Valeur Marge par Tranche
                            </Typography>
                            <div style={{ height: '300px' }}>
                                <Bar data={barData} options={barOptions} />
                            </div>
                        </Paper>
                    </Grid>
                </Grid>
                
                {/* Récapitulatif compact par tranches */}
                <Paper style={{ padding: '20px', marginBottom: '24px', backgroundColor: '#fafafa' }}>
                    <Typography variant="h6" style={{ marginBottom: 20, textAlign: 'center', color: '#115293', fontWeight: 600 }}>
                        Récapitulatif par Tranches de Marge
                    </Typography>
                    
                    <div style={{ 
                        display: 'flex', 
                        justifyContent: 'space-between', 
                        alignItems: 'stretch',
                        gap: '1px',
                        backgroundColor: '#e0e0e0',
                        borderRadius: '8px',
                        overflow: 'hidden'
                    }}>
                        {margeData.filter(t => t.count > 0).map((tranche, index) => (
                            <div
                                key={tranche.label}
                                style={{
                                    flex: 1,
                                    textAlign: 'center',
                                    padding: '16px 8px',
                                    backgroundColor: 'white',
                                    borderLeft: index === 0 ? 'none' : '1px solid #e0e0e0',
                                    position: 'relative'
                                }}
                            >
                                <div style={{
                                    fontSize: '0.875rem',
                                    fontWeight: 600,
                                    color: '#115293',
                                    marginBottom: '8px'
                                }}>
                                    {tranche.label}
                                </div>
                                
                                <div style={{
                                    fontSize: '1.25rem',
                                    fontWeight: 700,
                                    color: '#2c3e50',
                                    marginBottom: '4px'
                                }}>
                                    {tranche.count}
                                </div>
                                <div style={{
                                    fontSize: '0.75rem',
                                    color: '#6c757d',
                                    marginBottom: '8px'
                                }}>
                                    OF
                                </div>
                                
                                <div style={{
                                    fontSize: '0.95rem',
                                    fontWeight: 600,
                                    color: '#28a745',
                                    marginBottom: '2px'
                                }}>
                                    {new Intl.NumberFormat('fr-FR', { 
                                        style: 'currency', 
                                        currency: 'EUR', 
                                        maximumFractionDigits: 0 
                                    }).format(tranche.marge)}
                                </div>
                                <div style={{
                                    fontSize: '0.7rem',
                                    color: '#6c757d'
                                }}>
                                    Moy: {new Intl.NumberFormat('fr-FR', { 
                                        style: 'currency', 
                                        currency: 'EUR', 
                                        maximumFractionDigits: 0 
                                    }).format(tranche.marge / tranche.count)}
                                </div>
                            </div>
                        ))}
                    </div>
                </Paper>
            </>
        );
    };

    renderChartsLivres = () => {
        const { classes } = this.props;
        const margeData = this.getMargeAbsolueDataLivres();

        if (!margeData.length || margeData.every(t => t.count === 0)) return null;

        // Configuration pour le graphique en secteurs (par nombre de commandes)
        const doughnutData = {
            labels: margeData.filter(t => t.count > 0).map(item => item.label),
            datasets: [{
                data: margeData.filter(t => t.count > 0).map(item => item.count),
                backgroundColor: [
                    '#e74c3c',  // <100€
                    '#f39c12',  // <200€
                    '#f1c40f',  // <300€
                    '#3498db',  // <500€
                    '#2ecc71',  // <1000€
                    '#27ae60'   // >1000€
                ],
                borderWidth: 2,
                borderColor: '#fff'
            }]
        };

        const doughnutOptions = {
            responsive: true,
            maintainAspectRatio: false,
            legend: {
                position: 'bottom'
            }
        };

        // Configuration pour le graphique en barres (par valeur de marge)
        const barData = {
            labels: margeData.filter(t => t.count > 0).map(item => item.label),
            datasets: [{
                label: 'Marge Totale (€)',
                data: margeData.filter(t => t.count > 0).map(item => item.marge),
                backgroundColor: 'rgba(46, 204, 113, 0.8)',
                borderColor: 'rgba(46, 204, 113, 1)',
                borderWidth: 2
            }]
        };

        const barOptions = {
            responsive: true,
            maintainAspectRatio: false,
            scales: {
                yAxes: [{
                    ticks: {
                        beginAtZero: true,
                        callback: function(value) {
                            return new Intl.NumberFormat('fr-FR').format(value) + ' €';
                        }
                    }
                }]
            },
            legend: {
                display: false
            },
            layout: {
                padding: {
                    top: 30
                }
            },
            tooltips: {
                callbacks: {
                    label: function(tooltipItem, data) {
                        const value = tooltipItem.yLabel;
                        return 'Marge: ' + new Intl.NumberFormat('fr-FR', { 
                            style: 'currency', 
                            currency: 'EUR', 
                            maximumFractionDigits: 0 
                        }).format(value);
                    }
                }
            }
        };

        return (
            <>
                <Grid container spacing={3} style={{ marginBottom: 24 }}>
                    <Grid item xs={12} md={6}>
                        <Paper className={classes.chartCard}>
                            <Typography variant="h6" style={{ marginBottom: 16, textAlign: 'center' }}>
                                Répartition par Marge (OFs Livrés)
                            </Typography>
                            <div style={{ height: '300px' }}>
                                <Doughnut data={doughnutData} options={doughnutOptions} />
                            </div>
                        </Paper>
                    </Grid>
                    <Grid item xs={12} md={6}>
                        <Paper className={classes.chartCard}>
                            <Typography variant="h6" style={{ marginBottom: 16, textAlign: 'center' }}>
                                Valeur Marge par Tranche (OFs Livrés)
                            </Typography>
                            <div style={{ height: '300px' }}>
                                <Bar data={barData} options={barOptions} />
                            </div>
                        </Paper>
                    </Grid>
                </Grid>
                
                {/* Récapitulatif compact par tranches pour les livrés */}
                <Paper style={{ padding: '20px', marginBottom: '24px', backgroundColor: '#f0f8f5' }}>
                    <Typography variant="h6" style={{ marginBottom: 20, textAlign: 'center', color: '#27ae60', fontWeight: 600 }}>
                        Récapitulatif par Tranches de Marge - OFs Livrés
                    </Typography>
                    
                    <div style={{ 
                        display: 'flex', 
                        justifyContent: 'space-between', 
                        alignItems: 'stretch',
                        gap: '1px',
                        backgroundColor: '#d4e6dc',
                        borderRadius: '8px',
                        overflow: 'hidden'
                    }}>
                        {margeData.filter(t => t.count > 0).map((tranche, index) => (
                            <div
                                key={tranche.label}
                                style={{
                                    flex: 1,
                                    textAlign: 'center',
                                    padding: '16px 8px',
                                    backgroundColor: 'white',
                                    borderLeft: index === 0 ? 'none' : '1px solid #d4e6dc',
                                    position: 'relative'
                                }}
                            >
                                <div style={{
                                    fontSize: '0.875rem',
                                    fontWeight: 600,
                                    color: '#27ae60',
                                    marginBottom: '8px'
                                }}>
                                    {tranche.label}
                                </div>
                                
                                <div style={{
                                    fontSize: '1.25rem',
                                    fontWeight: 700,
                                    color: '#2c3e50',
                                    marginBottom: '4px'
                                }}>
                                    {tranche.count}
                                </div>
                                <div style={{
                                    fontSize: '0.75rem',
                                    color: '#6c757d',
                                    marginBottom: '8px'
                                }}>
                                    OF Livrés
                                </div>
                                
                                <div style={{
                                    fontSize: '0.95rem',
                                    fontWeight: 600,
                                    color: '#27ae60',
                                    marginBottom: '2px'
                                }}>
                                    {new Intl.NumberFormat('fr-FR', { 
                                        style: 'currency', 
                                        currency: 'EUR', 
                                        maximumFractionDigits: 0 
                                    }).format(tranche.marge)}
                                </div>
                                <div style={{
                                    fontSize: '0.7rem',
                                    color: '#6c757d'
                                }}>
                                    Moy: {new Intl.NumberFormat('fr-FR', { 
                                        style: 'currency', 
                                        currency: 'EUR', 
                                        maximumFractionDigits: 0 
                                    }).format(tranche.marge / tranche.count)}
                                </div>
                            </div>
                        ))}
                    </div>
                </Paper>
            </>
        );
    };

    renderFilters = () => {
        const { classes, listeStade, listeMetaux, listeTypeProduit } = this.props;

        return (
            <div className={classes.filterSection}>
                <div className='row'>
                    <div className="col-auto">
                        <TreeClient 
                            onChange={this.handleChangeClient}
                            client={this.state.client}
                        />
                    </div>

                    <div className="col-sm" style={{ padding: '4px' }}>
                        <TextField
                            label="Date début"
                            type="date"
                            value={this.state.debut}
                            onChange={(e) => this.setState({ debut: e.target.value })}
                            InputLabelProps={{ shrink: true }}
                            fullWidth
                            variant="outlined"
                            size="small"
                            margin="dense"
                        />
                    </div>
                    
                    <div className="col-sm" style={{ padding: '4px' }}>
                        <TextField
                            label="Date fin"
                            type="date"
                            value={this.state.fin}
                            onChange={(e) => this.setState({ fin: e.target.value })}
                            InputLabelProps={{ shrink: true }}
                            fullWidth
                            variant="outlined"
                            size="small"
                            margin="dense"
                        />
                    </div>

                    <div className="col-sm" style={{ padding: '4px 2px 0px 2px' }}>
                        <FilterSelect 
                            label="Stade" 
                            labelId='id_stade'
                            options={listeStade} 
                            onChange={this.onChange}
                        />
                    </div>
                    
                    <div className="col-sm" style={{ padding: '4px 2px 0px 2px' }}>
                        <FilterSelect 
                            label="Métal" 
                            labelId='id_type'
                            options={listeMetaux} 
                            onChange={this.onChange}
                        />
                    </div>
                    
                    <div className="col-sm" style={{ padding: '4px 2px 0px 2px' }}>
                        <FilterSelect 
                            label="Type" 
                            labelId='id_typ_prod'
                            options={listeTypeProduit} 
                            onChange={this.onChange}
                        />
                    </div>
                    
                    <div className="col-sm" style={{ padding: '4px 2px 0px 2px' }}>
                        <FilterInput 
                            label="Référence" 
                            onChange={this.onChange}
                        />
                    </div>
                    
                    <div className="col-sm" style={{ padding: '4px' }}>
                        <Button
                            variant="contained"
                            className={classes.refreshButton}
                            onClick={this.loadAllData}
                            startIcon={<Refresh />}
                            fullWidth
                            style={{ height: '40px' }}
                        >
                            Actualiser
                        </Button>
                    </div>
                </div>
            </div>
        );
    };

    renderTable = (isLivre = false) => {
        const { classes, analyseMarges } = this.props;
        const { efficaciteData, efficaciteDataLivres } = analyseMarges;
        const { page, rowsPerPage } = this.state;

        // Utiliser les bonnes données selon le mode (livré ou pas)
        const currentData = isLivre ? efficaciteDataLivres : efficaciteData;
        
        if (!currentData.length) return null;

        const displayedData = currentData.slice(page * rowsPerPage, page * rowsPerPage + rowsPerPage);
        
        // Titre selon le mode
        const titleText = isLivre ? "Top Performances - Analyses OFs Livrés" : "Top Performances - Analyse Détaillée";

        return (
            <TableContainer component={Paper} className={classes.tableContainer}>
                <Typography variant="h6" style={{ padding: 16 }}>
                    <span role="img" aria-label="chart">📊</span> {titleText}
                </Typography>
                <Table>
                    <TableHead>
                        <TableRow style={{ backgroundColor: '#f5f5f5' }}>
                            <TableCell align="center"><strong>OF</strong></TableCell>
                            <TableCell align="center"><strong>Référence</strong></TableCell>
                            <TableCell align="right"><strong>CA (€)</strong></TableCell>
                            <TableCell align="right"><strong>Coût (€)</strong></TableCell>
                            <TableCell align="right"><strong>Marge (€)</strong></TableCell>
                            <TableCell align="right"><strong>Marge (%)</strong></TableCell>
                            <TableCell align="center"><strong>Classe</strong></TableCell>
                            <TableCell align="right"><strong>Temps (MO)</strong></TableCell>
                            <TableCell align="right"><strong>Efficacité (€/h)</strong></TableCell>
                            {/* Colonne poids réel uniquement pour les OFs livrés */}
                            {isLivre && <TableCell align="right"><strong>Poids réel (g)</strong></TableCell>}
                        </TableRow>
                    </TableHead>
                    <TableBody>
                        {displayedData.map((row, index) => (
                            <TableRow key={row.num_sachet} hover>
                                <TableCell align="center" style={{ fontWeight: 'bold', borderRight: '1px solid #e0e0e0' }}>
                                    {row.num_sachet}
                                </TableCell>
                                <TableCell align="center" style={{ borderRight: '1px solid #e0e0e0' }}>
                                    {row.ref_cv || row.ref}
                                </TableCell>
                                <TableCell align="right" className="euro" style={{ borderRight: '1px solid #e0e0e0' }}>
                                    {this.formatNumber(row.prix_fact)} €
                                </TableCell>
                                <TableCell align="right" className="euro" style={{ borderRight: '1px solid #e0e0e0' }}>
                                    {this.formatNumber(row.revient_piece)} €
                                </TableCell>
                                <TableCell align="right" className={row.marge >= 0 ? classes.positiveValue : classes.negativeValue} style={{ borderRight: '1px solid #e0e0e0' }}>
                                    {this.formatNumber(row.marge)} €
                                </TableCell>
                                <TableCell align="right" className={row.pourcentage_marge >= 30 ? classes.positiveValue : classes.negativeValue} style={{ borderRight: '1px solid #e0e0e0' }}>
                                    {row.pourcentage_marge}%
                                </TableCell>
                                <TableCell align="center" style={{ borderRight: '1px solid #e0e0e0' }}>
                                    {this.getStatusChip(row.pourcentage_marge, row.marge, classes)}
                                </TableCell>
                                <TableCell align="right" style={{ borderRight: '1px solid #e0e0e0' }}>
                                    {this.formatNumber(row.temps_mo || 0)} h
                                </TableCell>
                                <TableCell align="right" style={{ borderRight: isLivre ? '1px solid #e0e0e0' : 'none' }}>
                                    {this.formatNumber(row.efficacite_temps)} €/h
                                </TableCell>
                                {/* Affichage du poids réel uniquement pour les OFs livrés */}
                                {isLivre && (
                                    <TableCell align="right">
                                        {this.formatNumber(row.poids_u || 0)} g
                                    </TableCell>
                                )}
                            </TableRow>
                        ))}
                    </TableBody>
                </Table>
                <TablePagination
                    component="div"
                    count={currentData.length}
                    page={page}
                    onChangePage={this.handleChangePage}
                    rowsPerPage={rowsPerPage}
                    onChangeRowsPerPage={this.handleChangeRowsPerPage}
                    labelRowsPerPage="Lignes par page:"
                    labelDisplayedRows={({ from, to, count }) => 
                        `${from}-${to} sur ${count !== -1 ? count : `plus de ${to}`}`
                    }
                />
            </TableContainer>
        );
    };

    handleTabChange = (event, newValue) => {
        this.setState({ currentTab: newValue });
    };

    renderTabContent = () => {
        const { currentTab } = this.state;

        switch (currentTab) {
            case 0: // OFs En cours
                return (
                    <>
                        {this.renderCharts()}
                        {this.renderTable(false)} {/* false = pas livré */}
                    </>
                );
            case 1: // OFs Livrés
                return (
                    <>
                        {this.renderChartsLivres()}
                        {this.renderTable(true)} {/* true = livré */}
                    </>
                );
            default:
                return null;
        }
    };

    render() {
        const { classes } = this.props;
        const { loading, error, currentTab } = this.state;

        return (
            <div className={classes.root}>
                {/* En-tête */}
                <Card className={classes.headerCard}>
                    <CardContent style={{ textAlign: 'center', padding: 32 }}>
                        <Typography variant="h3" style={{ fontWeight: 'bold', marginBottom: 8 }}>
                            <span role="img" aria-label="trending up">📈</span> Analyse des Marges
                        </Typography>
                        <Typography variant="h6">
                            Dashboard de Performance Commerciale
                        </Typography>
                    </CardContent>
                </Card>

                {/* Filtres */}
                {this.renderFilters()}

                {/* KPIs */}
                {this.renderKPIs()}

                {/* Onglets */}
                <Paper style={{ marginBottom: 24 }}>
                    <Tabs 
                        value={currentTab} 
                        onChange={this.handleTabChange}
                        indicatorColor="primary"
                        textColor="primary"
                        variant="fullWidth"
                    >
                        <Tab label="OFs En cours" />
                        <Tab label="OFs Livrés" />
                    </Tabs>
                </Paper>

                {/* Gestion des états de chargement et d'erreur */}
                {loading && (
                    <Box display="flex" justifyContent="center" alignItems="center" style={{ height: 200 }}>
                        <CircularProgress size={60} />
                        <Typography variant="h6" style={{ marginLeft: 16 }}>
                            Chargement des données...
                        </Typography>
                    </Box>
                )}

                {error && (
                    <Paper style={{ padding: 16, backgroundColor: '#f8d7da', color: '#721c24', marginBottom: 24 }}>
                        <Typography variant="h6"><span role="img" aria-label="error">❌</span> {error}</Typography>
                    </Paper>
                )}

                {/* Contenu des onglets */}
                {!loading && !error && this.renderTabContent()}
            </div>
        );
    }
}

const mapStateToProps = (state) => ({
    listeStade: state.generalData.listeStade,
    listeMetaux: state.generalData.listeMetaux,
    listeTypeProduit: state.generalData.listeTypeProduit,
    listeStatut: state.generalData.listeStatut,
    analyseMarges: state.analyseMarges
});

const mapDispatchToProps = {
    getStade,
    getMetaux,
    getTypeProduit,
    getStatut,
    getAnalyseMargeTotaux,
    getAnalyseMargeClasses,
    getAnalyseMargeDetails,
    getAnalyseMargeEfficacite,
    getAnalyseMargeTotauxLivres,
    getAnalyseMargeClassesLivres,
    getAnalyseMargeDetailsLivres,
    getAnalyseMargeEfficaciteLivres
};

export default connect(mapStateToProps, mapDispatchToProps)(withStyles(useStyles)(AnalyseMarges));